module.exports = __webpack_public_path__ + "img/play-store.8b729289.png";